import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_2 = { class: "flex items-center justify-end mt-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "px-6 py-4 border bg-white",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_the_select, {
        "can-deselect": "",
        "is-invalid": _ctx.state_form$.typeId.$error,
        "validation-errors": _ctx.state_form$.typeId.$errors,
        placeholder: "Вид услуги",
        options: _ctx.data_state.changes_history.list,
        value: _ctx.state.typeId,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.typeId) = $event)),
        loading: _ctx.data_state.changes_history.is_loading,
        failed: _ctx.data_state.changes_history.is_failed,
        "error-text": "При получении списка видов услуг произошла ошибка",
        onRefresh: _ctx.loadHistoryTypes,
        disabled: _ctx.loading,
        label: "description",
        class: "mt-2"
      }, null, 8, ["is-invalid", "validation-errors", "options", "value", "loading", "failed", "onRefresh", "disabled"]),
      _createVNode(_component_the_input, {
        "is-invalid": _ctx.state_form$.clientId.$error,
        "validation-errors": _ctx.state_form$.clientId.$errors,
        placeholder: "Номер",
        disabled: _ctx.loading,
        value: _ctx.state.clientId,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.clientId) = $event))
      }, null, 8, ["is-invalid", "validation-errors", "disabled", "value"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        class: "mt-2",
        placeholder: "Тип действия",
        options: _ctx.HISTORY_TYPES,
        value: _ctx.state.actionId,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.actionId) = $event)),
        disabled: _ctx.loading
      }, null, 8, ["options", "value", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_the_button, {
        class: "small second text mr-3",
        type: "button",
        loading: _ctx.loading,
        onClick: _ctx.onReset
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Сбросить ")
        ]),
        _: 1
      }, 8, ["loading", "onClick"]),
      _createVNode(_component_the_button, {
        class: "small primary text",
        loading: _ctx.loading,
        type: "submit"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}